export function Wrap<Args extends unknown[]>({
  renderWrapper,
  renderChildren,
}: {
  renderWrapper: (
    renderChildren: (...args: NoInfer<Args>) => React.ReactNode,
  ) => React.ReactNode;
  renderChildren: (...args: Args) => React.ReactNode;
}) {
  return renderWrapper(renderChildren);
}
